/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setProfilePhotoInternal} from '../api'

export const useMutationSetProfilePhotoInternal = createReactQueryMutationHook('setProfilePhotoInternal', setProfilePhotoInternal)
